<template>
  <div>
    <b-alert
      variant="primary"
      :show="show"
    >
      <div class="alert-body">
        <span>Equipos Contrato</span>
      </div>
    </b-alert>
    <b-card
      no-body
      class="mb-0 mt-1"
      title="Equipo"
      :show="!show"
    >
      <div class="m-2">
        <b-col md="12">
          <div class="demo-inline-spacing">
            <b-button
              v-if="!working"
              variant="primary"
              class="float-left"
              @click="search()"
            >
              <feather-icon icon="SearchIcon" />
              <span class="align-middle">Consultar Equipos</span>
            </b-button>
            <b-button
              v-else
              variant="dark"
              class="float-left"
              disabled
            >
              <b-spinner small />
              Procesando...
            </b-button>
          </div>
        </b-col>

        <!-- BUSQUEDA -->
        <div
          class="m-2"
          md="12"
        >
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Ver</label>
              <v-select
                v-model="perPage"
                :dir="
                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                "
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>Lista</label>
            </b-col>

            <!-- Search -->
            <b-col
              cols="12"
              md="6"
            >
              <div
                class="d-flex align-items-center justify-content-end"
              >
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Buscar..."
                />
                <b-button
                  variant="primary"
                  @click="showModalOtNewEquipment"
                >
                  <span class="text-nowrap">
                    <feather-icon icon="PlusIcon" />
                    Solicitar Nuevo Equipo
                  </span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- FIN BUSQUEDA-->

        <!-- INICIO TABLE-->
        <div id="printEquipment">
          <b-table
            id="my-table"
            ref="refUserListTable"
            class="position-relative"
            striped
            hover
            small
            responsive
            show-empty
            :items="dataReport"
            :fields="columns"
            :sort-by.sync="sortBy"
            :sort-desc.sync="isSortDirDesc"
            :filter="searchQuery"
            :per-page="perPage"
            :current-page="currentPage"
            empty-text="No existen registros para mostrar"
          >
            <!-- serial -->
            <template #cell(serial)="row">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    :id="`equipo-${row.item.equipo.idcontratoequipo}`"
                    size="30"
                    :variant="`light-${row.item.equipo.tipoprodclass}`"
                  >
                    <feather-icon
                      :icon="
                        row.item.equipo.tipoprodicono
                      "
                    />
                  </b-avatar>
                </template>

                <div
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ row.item.equipo.serial }}
                </div>
              </b-media>
            </template>
            <!-- / serial -->

            <!-- estado -->
            <template #cell(estado)="row">
              <b-badge
                pill
                :variant="row.item.equipo.class"
              >
                {{ row.item.equipo.estado }}
              </b-badge>
            </template>
            <!-- / estado -->

            <!-- equipo -->
            <template #cell(equipo)="row">
              <span
                v-if="
                  row.item.equipo.equipo_olt !== '' &&
                    row.item.equipo.equipo_olt !== null
                "
                class="d-block text-nowrap"
              >
                {{ row.item.equipo.equipo_olt }}
              </span>
              <span
                v-if="
                  row.item.equipo.equipo_cas !== '' &&
                    row.item.equipo.equipo_cas !== null
                "
                class="d-block text-nowrap"
              >
                {{ row.item.equipo.equipo_cas }}
              </span>
            </template>
            <!-- / equipo -->

            <!-- acciones -->
            <template #cell(acciones)="">
              <div class="text-nowrap" />
            </template>
            <!-- / acciones -->
          </b-table>
        </div>
        <!-- / table -->

        <!-- paginate -->
        <b-col cols="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            hide-goto-end-buttons
            :per-page="perPage"
            align="center"
            aria-controls="my-table"
            size="md"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          />
        </b-col>

        <modal-ot-new-equipment :idcontrato="idcontrato" />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
    BAlert,
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCol,
    BFormInput,
    BMedia,
    BPagination,
    BRow,
    BSpinner,
    BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ModalOtNewEquipment from './modal/ModalOtNewEquipment.vue'
import useList from './useList'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BFormInput,
        BTable,
        BSpinner,
        BBadge,
        BPagination,
        BAvatar,
        BMedia,
        BAlert,
        ModalOtNewEquipment,
        vSelect,
    },
    directives: {
        Ripple,
    },
    props: {
        idcontrato: {
            type: Number,
            required: true,
        },
        data: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            working: false,
            userData: JSON.parse(localStorage.getItem('userData')),
            ot: {
                tipo: null,
            },
            contractEquipment: {},
            dataReport: [],
            columns: [
                { key: 'serial', label: 'serial', sortable: true },
                {
                    key: 'equipo.fecha',
                    label: 'Fecha',
                    sortable: true,
                    formatter: 'dateFormat',
                },
                { key: 'equipo.ubicacion', label: 'ubicacion', sortable: true },
                {
                    key: 'equipo.paquetes',
                    label: 'paquete',
                    sortable: true,
                    formatter: 'formatPlan',
                    sortByFormatted: true,
                },
                {
                    key: 'estado',
                    label: 'estado',
                    sortable: true,
                    formatter: 'formatStatus',
                    sortByFormatted: true,
                },
            ],
            show: true,
            header: {},
        }
    },
    computed: {
        totalRows() {
            return this.dataReport.length
        },
    },
    created() {
        if (this.data != null) {
            this.header = {
                codigo: this.data.codigo,
                apenom: this.data.apenom,
            }
        }
        if (typeof this.idcontrato !== 'undefined') {
            this.show = false
            this.search()
        }
    },
    methods: {
        newForm() {
            this.$router.go(0)
        },
        search() {
            this.working = true
            this.$http
                .get('/contrato-equipo', {
                    params: {
                        idcontrato: this.idcontrato,
                    },
                })
                .then((response) => {
                    this.working = false
                    this.dataReport = response.data.data
                })
                .catch((error) => {
                    this.working = false
                    this.$swal({
                        title: 'Error',
                        text: error.response.data.error,
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        },
        showModalOtNewEquipment() {
            this.$root.$emit('bv::show::modal', 'modal-ot-new-equipment')
        },
        reload() {
            this.search()
        },
        formatPlan(value) {
            if (value.length > 0) {
                return `${value[0].nombre} - ${value[0].precio}`
            }
            return ''
        },
        dateFormat (string) {
            if (string == null) return ''
            return string.split('-').reverse().join('/')
        },
    }, // fin methods
    setup() {
        const {
            perPage,
            currentPage,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refUserListTable,
            refetchData,
        } = useList()

        return {
            perPage,
            currentPage,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refUserListTable,
            refetchData,
        }
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
